import type { CrudSearchItem, CrudTableColumn } from '@/types/crud-config'
import type { PointRecord, UserPointRecord } from './point.service'

export const pointSearchItems: CrudSearchItem[] = [
  {
    label: '账号',
    prop: 'loginName',
    type: 'input',
    controlClass: 'point-page__search-input',
    clearable: true,
    placeholder: '请输入账号'
  },
  {
    label: '昵称',
    prop: 'nickName',
    type: 'input',
    controlClass: 'point-page__search-input',
    clearable: true,
    placeholder: '请输入昵称'
  }
]

export function createUserPointTableColumns(
  showActions: boolean
): CrudTableColumn<UserPointRecord>[] {
  const columns: CrudTableColumn<UserPointRecord>[] = [
    {
      prop: 'loginName',
      label: '账号',
      minWidth: 120,
      showOverflowTooltip: true
    },
    {
      prop: 'nickName',
      label: '昵称',
      minWidth: 140,
      showOverflowTooltip: true
    },
    {
      prop: 'point',
      label: '金币数量',
      minWidth: 120,
      showOverflowTooltip: true
    }
  ]

  if (showActions) {
    columns.push({
      label: '操作',
      slot: 'rowActions',
      minWidth: 430,
      fixed: 'right'
    })
  }

  return columns
}

export const pointRecordTableColumns: CrudTableColumn<PointRecord>[] = [
  {
    prop: 'reason',
    label: '原因',
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'num',
    label: '金币数量',
    minWidth: 100,
    showOverflowTooltip: true
  },
  {
    prop: 'remark',
    label: '备注',
    minWidth: 160,
    showOverflowTooltip: true
  },
  {
    prop: 'createdTime',
    label: '操作时间',
    minWidth: 170,
    showOverflowTooltip: true
  }
]
